'use client';

import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["className", "render", "style"];
import * as React from 'react';
import { useStore } from '@base-ui/utils/store';
import { useRenderElement } from '@mui/x-scheduler-internals/base-ui-copy';
import { useAdapterContext } from '@mui/x-scheduler-internals/use-adapter-context';
import { useElementPositionInCollection } from '@mui/x-scheduler-internals/internals';
import { schedulerNowSelectors } from '@mui/x-scheduler-internals/scheduler-selectors';
import { processDate } from '@mui/x-scheduler-internals/process-date';
import { useEventTimelinePremiumStoreContext } from "../../use-event-timeline-premium-store-context/index.mjs";
import { eventTimelinePremiumPresetSelectors } from "../../event-timeline-premium-selectors/index.mjs";
import { TimelineGridCurrentTimeIndicatorCssVars } from "./TimelineGridCurrentTimeIndicatorCssVars.mjs";
export const TimelineGridCurrentTimeIndicator = /*#__PURE__*/React.forwardRef(function TimelineGridCurrentTimeIndicator(componentProps, forwardedRef) {
  const adapter = useAdapterContext();
  const elementProps = _objectWithoutPropertiesLoose(componentProps, _excluded);
  const store = useEventTimelinePremiumStoreContext();
  const now = useStore(store, schedulerNowSelectors.nowUpdatedEveryMinute);
  const presetConfig = useStore(store, eventTimelinePremiumPresetSelectors.config);
  const processedNow = React.useMemo(() => processDate(now, adapter), [adapter, now]);
  const endForCalc = React.useMemo(() => processDate(adapter.addMinutes(now, 1), adapter), [adapter, now]);
  const {
    position
  } = useElementPositionInCollection({
    start: processedNow,
    end: endForCalc,
    collectionStart: presetConfig.start,
    collectionEnd: presetConfig.end
  });
  const isOutOfRange = adapter.isBefore(now, presetConfig.start) || adapter.isAfter(now, presetConfig.end);
  return useRenderElement('div', componentProps, {
    ref: [forwardedRef],
    props: [elementProps, {
      style: {
        [TimelineGridCurrentTimeIndicatorCssVars.xPosition]: position
      }
    }],
    enabled: !isOutOfRange
  });
});
if (process.env.NODE_ENV !== "production") TimelineGridCurrentTimeIndicator.displayName = "TimelineGridCurrentTimeIndicator";